import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_CLIENT_COLLECTION_AGENT: string = typeCreatorV2(
  'ClientCollectionReducer',
  'SetClientCollectionAgent'
);
export const SET_CLIENT_COLLECTION_PERSONAL: string = typeCreatorV2(
  'ClientCollectionReducer',
  'SetClientCollectionPersional'
);
export const DELETE_CLIENT_COLLECTION: string = typeCreatorV2(
  'ClientCollectionReducer',
  'DeleteClientCollection'
);

export const SET_CUSTOMERS: string = typeCreatorV2(
  'ClientCollectionReducer',
  'SetCustomerClientCollection'
);

export const CLIENT_SHARE_COLLECTIONS: string = typeCreatorV2(
  'ClientCollectionReducer',
  'ShareClientCollection'
);

export const SET_CLIENT_FAVOURITE_PRODUCTS: string = typeCreatorV2(
  'ClientCollectionReducer',
  'SetClientFavouriteProducts'
);

export const SET_ASSIGN_CLIENTS_PRODUCTS: string = typeCreatorV2(
  'ClientCollectionReducer',
  'SetAssignClientsProducts'
);

export const SET_ADD_ASSIGN_CLIENTS: string = typeCreatorV2(
  'ClientCollectionReducer',
  'SetAddAssignClients'
);
